import { Product } from '../types';

export const products: Product[] = [
  {
    id: '1',
    brand: 'K-Gas',
    image: 'kgas.png',
    description: 'Premium LPG gas for all your cooking needs',
    prices: {
      '6kg': {
        new: 2100,
        refill: 800
      },
      '13kg': {
        new: 5100,
        refill: 2500
      }
    }
  },
  {
    id: '2',
    brand: 'Total Gas',
    image: 'total.png',
    description: 'High-quality cooking gas from Total',
    prices: {
      '6kg': {
        new: 2100,
        refill: 800
      },
      '13kg': {
        new: 5100,
        refill: 2500
      }
    }
  },
  {
    id: '3',
    brand: 'Pro Gas',
    image: 'progas.png',
    description: 'Reliable cooking gas solution',
    prices: {
      '6kg': {
        new: 2100,
        refill: 800
      },
      '13kg': {
        new: 5100,
        refill: 2500
      }
    }
  },
  {
    id: '4',
    brand: 'Supa Gas',
    image: 'supagas.jpg',
    description: 'Quality and affordable cooking gas solution',
    prices: {
      '6kg': {
        new: 2100,
        refill: 800
      },
      '13kg': {
        new: 5100,
        refill: 2500
      }
    }
  }
];

export const accessories: Product[] = [
  {
    id: 'acc-1',
    brand: 'SafeGas gas Regulator 6kg',
    image: 'regulator6kg.jpg',
    description: 'High-quality gas regulator for 6kg cylinders with safety valve',
    type: 'accessory',
    price: 850
  },
  {
    id: 'acc-2',
    brand: 'SafeGas gas Regulator 13kg',
    image: 'regulator.jpg',
    description: 'Heavy-duty gas regulator for 13kg cylinders with safety valve',
    type: 'accessory',
    price: 1200
  },
  {
    id: 'acc-3',
    brand: 'FlexiPipe 1.5m',
    image: 'pipe.png',
    description: 'Standard 1.5-meter gas hose pipe with reinforced walls',
    type: 'accessory',
    price: 450
  },
  {
    id: 'acc-4',
    brand: 'FlexiPipe 2m',
    image: 'pipe.png',
    description: 'Extended 2-meter gas hose pipe with reinforced walls',
    type: 'accessory',
    price: 600
  },
  {
    id: 'acc-5',
    brand: 'CompactBurner',
    image: 'burner.png',
    description: 'Single burner stove compatible with 6kg cylinders',
    type: 'accessory',
    price: 2500
  },
  {
    id: 'acc-6',
    brand: 'GrillMaster',
    image: 'grill.png',
    description: 'Premium gas grill for outdoor cooking, compatible with 6kg cylinders',
    type: 'accessory',
    price: 4500
  }
];